<div class="p2 b-a inline-block center box">
    <ng-content></ng-content>
</div>